import { createContext } from 'react';

import { Order, TradeMethod } from 'types';

export type OrderContextProps = {
  order?: Order;
  tradeMethod?: TradeMethod;
  isTSBP?: boolean;
  isSBP?: boolean;
  isSIM?: boolean;
  isTSBPSingleBankSelection?: boolean;
  isCard2Card?: boolean;
  isTCard2Card?: boolean;
  qrCodeUrl?: string;
  nspkUrl?: string;
  requisitesBankName?: string;
  customerBank?: string;
  customerBankName?: string;
  getBankNameByCode?: (code?: string) => string;
};

export const OrderContext = createContext<OrderContextProps>(
  {} as OrderContextProps,
);
